import { Link } from "react-router-dom";
import { LogoFooter } from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bsp-footer font_family_base">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <LogoFooter />
      </div>
      <p style={{ marginTop: 16, color: "#c7cbd1" }}>
        <a href="mailto:brian@bstrongperformance.com">
          brian@BStrongPerformance.com
        </a>
      </p>
      <div className="bsp-footer-links">
        <Link to="/">Home</Link>
        <Link to="/services">Services</Link>
        <Link to="/about">About BStrong</Link>
        <Link to="/bookshelf">Bookshelf</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/privacy">Privacy Policy</Link>
      </div>
      <div className="bsp-footer-copy">
        © {year} BStrong Performance. All rights reserved.
      </div>
    </footer>
  );
}
